import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const WASTE_CODES_STORE_KEY = 'wasteCodes';

const initialState: string[] = [];

const wasteCodesSlice = createSlice({
  name: WASTE_CODES_STORE_KEY,
  initialState,
  reducers: {
    setSelectedWasteCodes: (state: string[], action: PayloadAction<string[]>) => {
      state = action.payload ?? [];
      return state;
    },
  },
});

export const { setSelectedWasteCodes } = wasteCodesSlice.actions;
export const wasteCodesReducer = wasteCodesSlice.reducer;
